import { Button, Slot, Slottable, VisuallyHidden } from '@farol-ds/react'
import { PaymentIcon, PaymentIconMethod } from '@jusbrasil-web/shared-payment-icon'
import classNames from 'classnames'
import { ButtonHTMLAttributes, forwardRef, ReactNode, useId } from 'react'

import styles from './payment-method-button.module.scss'

export type PaymentMethodButtonElement = HTMLButtonElement
export interface PaymentMethodButtonProps extends ButtonHTMLAttributes<PaymentMethodButtonElement> {
  method: PaymentIconMethod
  label?: string
  helpText?: string
  children?: ReactNode
  disabled?: boolean
  className?: string
  asChild?: boolean
}

export const PaymentMethodButton = forwardRef<PaymentMethodButtonElement, PaymentMethodButtonProps>(
  function PaymentMethodButton(props, forwardedRef) {
    const {
      children,
      method,
      disabled,
      className,
      asChild,
      label,
      helpText,
      id: idProp,
      ...rest
    } = props

    const Component = asChild ? Slot : 'button'

    const uuid = useId()
    const id = idProp || uuid
    const labelId = `${id}-label`
    const helpTextId = `${id}-helptext`
    const btnId = `${id}-btn`

    const labelledby = [label && labelId, helpText && helpTextId, btnId].filter(Boolean).join(' ')

    const classes = classNames(
      styles.root,
      {
        [styles.disabled]: !!disabled,
      },
      className
    )

    return (
      <Component
        className={classes}
        aria-labelledby={labelledby}
        id={id}
        disabled={disabled}
        {...rest}
        ref={forwardedRef}
      >
        <Slottable>{children}</Slottable>

        <div className={styles.icon}>
          <PaymentIcon method={method} />
        </div>

        <div className={styles.info}>
          {label && (
            <p className={styles.label} id={labelId}>
              {label}
            </p>
          )}
          {helpText && (
            <p className={styles.helpText} id={helpTextId}>
              {helpText}
            </p>
          )}
        </div>

        <Button
          kind="plain"
          size="md"
          disabled={disabled}
          className={styles.button}
          tabIndex={-1}
          role="none"
          asChild
        >
          <span>Alterar</span>
        </Button>
        <VisuallyHidden id={btnId}>clique para alterar</VisuallyHidden>
      </Component>
    )
  }
)
